<ng-container *ngIf="flowDesign && chatFlow">
  <div
    class="chat-bot-container"
    style="height: 100%"
    (pointerdown)="onChatbotUserInteraction($event)"
    (keydown)="onChatbotUserInteraction($event)"
  >
    <button class="skip-to-content" (click)="skipToContent()">
      {{ 'skip_to_content' | translate }}
    </button>
    <h1 class="sr-only" id="chatbot-heading" tabindex="-1">
      {{ funnelTitle }}
    </h1>
    <p class="sr-only" *ngIf="funnelDescription">{{ funnelDescription }}</p>
    <header
      class="app-header"
      [attr.aria-label]="funnelTitle"
      [style.background-color]="flowDesign.header_background_color"
    >
      <div class="app-header-content">
        <div class="comp-logo" style="display: flex; align-items: center">
          <a
            [href]="flowDesign.company_url"
            target="_blank"
            rel="noopener noreferrer"
            [attr.aria-label]="companyLogoAria"
          >
            <img
              [alt]="companyLogoAlt"
              [src]="flowDesign.company_logo_img_url"
              style="height: 52px"
            />
          </a>
        </div>
        <nav
          *ngIf="showLanguageSwitcher && chatFlow && funnelLanguage"
          [attr.aria-label]="'language_nav_label' | translate"
        >
          <language-switcher
            [defaultLanguage]="funnelLanguage"
            [languageObject]="chatFlow.language"
            (currentLanguageChanged)="onLanguageChanged($event)"
          ></language-switcher>
        </nav>
      </div>
    </header>
    <div
      class="app-container-chatbot"
      style="height: calc(100% - 72px)"
      [style.font-family]="
        (flowDesign.typography.custom_font_url
          ? 'CustomChatBotFont'
          : flowDesign.typography.font_family) +
        ', Montserrat, Arial, sans-serif'
      "
    >
      <div
        #scrollContainer
        class="chat-flow-component"
        *ngIf="steps"
        role="log"
        aria-live="polite"
        [attr.aria-label]="'chat_messages_aria' | translate"
        aria-relevant="additions"
        aria-atomic="false"
      >
        <!-- STEP COMPONENT -->
        <div class="steps-wrapper full-width" *ngIf="steps">
          <ng-container *ngIf="steps && funnelLanguage">
            <ng-container *ngFor="let step of steps; let i = index">
              <chat-step
                [step]="step"
                [flowDesign]="flowDesign"
                (scrollToBottom)="scrollToBottom()"
                [currentLang]="funnelLanguage"
                [testMode]="testMode"
                [isLastStep]="i === steps.length - 1"
                [restoredAnswer]="restoredAnswerAt(i)"
              ></chat-step>
            </ng-container>
          </ng-container>
        </div>
        <!-- // STEP COMPONENT -->
      </div>
    </div>
  </div>
</ng-container>
